export enum HallelValues {
  NoHallel = 0,
  HalfHallel = 1,
  FullHallel = 2,
}
